export type Point = {
  readonly x: number;
  readonly y: number;
};

export type CoordinatePair = {
  readonly p1: Point;
  readonly p2: Point;
};

export enum LockRange {
  min = 400,
  max = 1000,
}
